import { isEmbarcacaoSistemasDpEmpty } from "@/modules/embarcacoes/embarcacoes.types";
import type {
  EmbarcacaoSistemasDp,
  EmbarcacaoSistemasDpState,
} from "@/modules/embarcacoes/embarcacoes.types";
import {
  useEmbarcacaoDetailSection,
  type EmbarcacaoDetailSectionQuery,
} from "./use-embarcacao-detail-section";

const SISTEMAS_DP_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoSistemasDp> = {
  select: (ficha) => ficha.sistemasDp,
  isEmpty: isEmbarcacaoSistemasDpEmpty,
  secao: "os Sistemas de DP",
};

interface UseEmbarcacaoSistemasDpResult extends EmbarcacaoSistemasDpState {
  reload: () => void;
}

/**
 * Consulta os Sistemas de DP da embarcação pedida (AC4). Somente leitura:
 * nenhuma escrita é disparada na abertura nem no fechamento do modal.
 */
export function useEmbarcacaoSistemasDp(id: string): UseEmbarcacaoSistemasDpResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, SISTEMAS_DP_QUERY);

  return { ...state, sistemasDp: data };
}
